import { useMemo } from 'react';

import { CalendarIcon } from '@heroicons/react/24/outline';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { groupBy } from 'lodash-es';

import { useAppSelector } from 'src/app/store/hooks';
import { DispatchCalendarPDF } from 'src/features/dispatch/pdfs/DispatchCalendarPDF';

export function DownloadScheduleMenuItem() {
  const selectedDate = useAppSelector((state) => state.dispatcher.selectedDate);
  const dispatchResponse = useAppSelector(
    (state) => state.dispatcher.dispatchResponse
  );

  const assignments = useMemo(
    () => dispatchResponse?.assignments ?? [],
    [dispatchResponse]
  );

  const tripsByAssignmentId = useMemo(
    () =>
      groupBy(dispatchResponse?.assigned_trips ?? [], (t) => t.assignment_id),
    [dispatchResponse]
  );

  if (!assignments.length) {
    return null;
  }

  return (
    <div className="flex w-full items-center">
      <PDFDownloadLink
        document={
          <DispatchCalendarPDF
            selectedDate={selectedDate}
            assignments={assignments}
            tripsByAssignmentId={tripsByAssignmentId}
          />
        }
        data-testid="download-schedule"
        className="flex flex-row gap-2 text-xs hover:bg-gray-50"
        fileName={`${selectedDate}-schedule.pdf`}
      >
        <CalendarIcon className="h-4 w-4" />
        Download Schedule
      </PDFDownloadLink>
    </div>
  );
}
